import { Injectable } from '@angular/core';

import * as cryptoJS from 'crypto-js';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  options={
    headers: new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'})
  }

  constructor(
    private http: HttpClient
  ) { }


  login(user:any):Observable<any>{
    const key = cryptoJS.enc.Utf8.parse("8A8L8U80898R808AR3A04M43C3LAG738");
    const iv = cryptoJS.enc.Utf8.parse("8A8L8U80898R808A");

    const encryptedPassword = cryptoJS.AES.encrypt(
      cryptoJS.enc.Utf8.parse(user.Password),
      key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: cryptoJS.mode.CBC,
        padding: cryptoJS.pad.Pkcs7,
      }
    );

    let cadena = new URLSearchParams();
    // cadena.set('Password', ''+encryptedPassword);
    cadena.set('Password', user.Password);
    cadena.set('UserName', user.UserName);
    cadena.set('domain', user.domain);
    cadena.set('grant_type', user.grant_type);

    return this.http.post(environment.apiUrl + '/token', cadena.toString(), this.options)
  }

  getIdClient(token: string, idUser: string):  Observable<any> {
    const headers=new HttpHeaders(
      {
        'Authorization': 'Bearer '+token,
        'idUsuario': idUser
      }
    )
    return this.http.get(environment.apiUrl + `/api/Cliente/ObtenerDatosCliente/` , {headers: headers})
  }

  recoveryPassword(cadena:any):Observable<any>{
    return this.http.post(environment.apiUrl + '/api/Account/RecoveryPassword', cadena.toString(), this.options)
  }

  getToken(){
    const token = sessionStorage.getItem('access_token');
    return token;
  }

  getIdUsuario(){
    const idUsuario = sessionStorage.getItem('idUsuario') || '';
    return idUsuario;
  }

  setIdUsuario(idUsuario: string){
    sessionStorage.setItem('idUsuario', idUsuario)
  }

  getIdCliente(){
    const idCliente = sessionStorage.getItem('idCliente') || '';
    return idCliente;
  }

  setIdCliente(idCliente: string){
    sessionStorage.setItem('idCliente', idCliente)
  }

}
